/*! SH Specific */
$(function() {

  $(function() {
    var mobile = false;
    var tablet = false;
    var desktop = false;
    
    function checkWidth() {
      var viewportWidth = window.viewportSize.getWidth();
      if (viewportWidth <= 660) {
        if (!mobile) {
          $('.flexslider ul li a').not('.flexslider ul.flex-direction-nav li a').contents().unwrap();
          $('body').addClass('mobile').removeClass('desktop');
          $('.hdr-promo').insertBefore('.header-container');
        }
        mobile = true;
        desktop = false;
        tablet = false;
      } else if (viewportWidth >= 661 && viewportWidth <= 960) {
        if (!tablet) {
          $('.category blockquote').insertAfter('.category > div:last-child');
          $('body').removeClass('mobile').removeClass('desktop');
          $('.hdr-promo').insertBefore('.header-container');
        }
        mobile = false;
        desktop = false;
        tablet = true;
      } else {
        if (!desktop) {
          $('#main-nav').insertAfter('.top');
          $('.category blockquote').insertAfter('.category .item0');
          //$('ul.global-sites').prependTo('.utilities');
          $('#btn_global').prependTo('.global-sites > div');
          $('body').removeClass('mobile').addClass('desktop');		  
          $('.hdr-promo').insertBefore('.header-container');
          hoverEvents ();
        }
        mobile = false;
        desktop = true;
        tablet = false;
      }
    }

    checkWidth();
    $(window).on('resize', checkWidth);
  });

  /* --------------------------------------------------- */
  /* Header Menu & Toggles ----------------------------- */

  $(function() {
    /* Functions */
    function toggleSites() {
      $('.global-sites div .menu-wrapper').slideToggle('fast');
      $('#btn_global').toggleClass('sites-active sites-inactive');
      if ($(".global-sites #btn_global").hasClass('sites-active')) {
        setTimeout(() => {
            const sitesListLinks = document.querySelectorAll('.global-sites a');
            sitesListLinks[0].focus();
        }, 100);
      };
    }

    function toggleSearch() {
      $('#btn-search').toggleClass('search-active search-inactive').next().slideToggle('fast');
      if ($("#btn-search").hasClass('search-active')) {
        setTimeout(() => {
          const searchMenuFocusableEl = document.querySelectorAll('#tSearchContainer [data-ada-focusable="true"]');
          searchMenuFocusableEl[0].focus();
        }, 100);
      }
    }

    function toggleLeftNav() {
      $("#btn-left-nav").toggleClass('leftnav-active leftnav-inactive ').next().toggleClass('nav-opened');
    }

    function toggleTopNav(){
      $("#btn-main-nav").toggleClass('activated inactive');
      $('ul.top-nav').slideToggle('fast');  
    }

    function blurCloseSites(event) {
      if ($('.global-sites #btn_global').hasClass('sites-active')) { 
        const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
        let nextFocusParentID = null;
        if (event.relatedTarget) {
          nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null
        }
        if (currentParentID !== nextFocusParentID) {
          toggleSites(); 
        }
      }
    }

    function blurCloseSearch(event) {
      if ($('#btn-search').hasClass('search-active')) { 
        const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
        let nextFocusParentID = null;
        if (event.relatedTarget) {
          nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null
        }
        if (currentParentID !== nextFocusParentID) {
          toggleSearch(); 
        }
      }
    }

    function showHideSites () {
      //if( $('.global-sites #btn_global').hasClass('sites-active') ){ toggleSites() }
      if ($('#btn-search').hasClass('search-active')) { toggleSearch() }
      if ($('#btn-main-nav').hasClass('activated')) { toggleTopNav() }
      if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
      toggleSites();
      if( $('.global-sites #btn_global').hasClass('sites-active') ){ 
        const sitesListLinks = document.querySelectorAll('.global-sites a');
        sitesListLinks.forEach((el) => {
          el.addEventListener('blur', blurCloseSites);
        });
      };
    }

    function showHideSearch () {
      if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
      //if( $('#btn-search').hasClass('search-active') ){ toggleSearch() }
      if ($('#btn-main-nav').hasClass('activated')) { toggleTopNav() }
      if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
      toggleSearch();
      if( $('#btn-search').hasClass('search-active') ){ 
        const searchMenuFocusableEl = document.querySelectorAll('#tSearchContainer [data-ada-focusable="true"]');
        searchMenuFocusableEl.forEach((el) => {
          el.addEventListener('blur', blurCloseSearch);
        });
      }
    }

    function showHideAccount () {
      if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
      if( $('#btn-search').hasClass('search-active') ){ toggleSearch() }
      if ($('#btn-main-nav').hasClass('activated')) { toggleTopNav() }
      if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
    }

    $('.global-sites #btn_global').on('mousedown', showHideSites);
    $('.global-sites #btn_global').on('keydown', (event) => {
      if (event.key === 'Enter') {
        showHideSites();
      }
    });

    $('#btn-search').on('mousedown', showHideSearch);
    $('#btn-search').on('keydown', (event) => {
      if (event.key === 'Enter') {
        showHideSearch();
      }
    });

    $('#btn_menu_points').on('mousedown', showHideAccount);
    $('#btn_menu_points').on('keydown', (event) => {
      if (event.key === 'Enter') {
        showHideAccount();
      }
    });

    $("#btn-left-nav").on('click', function () {
      if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
      if ($('#btn-search').hasClass('search-active')) { toggleSearch() }
      if ($('#btn-main-nav').hasClass('activated')) { toggleTopNav() }
      //if( $('#btn-left-nav').hasClass('leftnav-active') ){ toggleLeftNav() }
      toggleLeftNav();
    });

    $("#btn-main-nav").on('click', function () {
      if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
      if ($('#btn-search').hasClass('search-active')) { toggleSearch() }
      //if( $('#btn-main-nav').hasClass('activated') ){ toggleTopNav() }
      if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
      toggleTopNav();
    });

    $('.global-sites > div > p').on('click', function(event){
      event.stopPropagation();
    });	
  });

  /* Promo Headers - */
  (function($) {
    $.fn.flowtype = function(options) {
        var settings = $.extend({
          maximum   : 9999,
          minimum   : 1,
          maxFont   : 9999,
          minFont   : 1,
          fontRatio : 35
        }, options),
        changes = function(el) {
          var $el = $(el),
              elw = $el.width(),
              width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
              fontBase = width / settings.fontRatio,
              fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
          $el.css('font-size', fontSize + 'px');
        };

        return this.each(function() {
          var that = this;
          $(window).on('resize', function(){changes(that);});
          changes(this);
        });
    };
  }(jQuery));
	
  $('.hdr-banner .promo-inner').flowtype({
    minimum   : 420,
    maximum   : 1200,
    minFont   : 20,
    //maxFont   : 45,
    fontRatio : 35
  });
  /*
  $('.hdr-banner.lastcall h3').flowtype({
    minimum   : 480,
    maximum   : 1200,
    minFont   : 15,
    //maxFont   : 45,
    fontRatio : 25
  });
  $('#bed-SH-101-SIM .hdr-banner.lastcall h3, #bed-SH-1210-SIM .hdr-banner.lastcall h3').flowtype({
    minimum   : 500,
    maximum   : 1200,
    minFont   : 18,
    //maxFont   : 45,
    fontRatio : 33
  });
  $('.hd-txt').flowtype({
    minimum   : 480,
    maximum   : 1200,
    minFont   : 13,
    maxFont   : 22,
    fontRatio : 27
  });
  $('.hd-txt.lcall').flowtype({
    minimum   : 480,
    maximum   : 1200,
    minFont   : 13,
    maxFont   : 22, 
    fontRatio : 27
  });
  */

  $(function() {
    //Equalize Columns
    $(function() {
      function equalheight (container) {
        var currentTallest = 0,
          currentRowStart = 0,
          rowDivs = new Array(),
          $el;
        $(container).each(function() {
          $el = $(this);
          $($el).height('auto')
          var topPostion = $el.position().top;
          var currentDiv;

          if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
              rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0;
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
          } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
          }
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
        });
      }
      $(window).on('load', function() {
        equalheight('.col-3');
      equalheight('.col');
      });
      $(window).on('resize', function() {
        equalheight('.col-3');
      equalheight('.col');
      });
    });
    
    var root = document.getElementsByTagName( 'html' )[0];
    if (!document.createElement('svg').getAttributeNS) {
      root.setAttribute( "class", "no-svg" );
      return;
    }
  });

  $('.shop-cart')
    .on('mouseover', function() { // Mouseenter (used with .hover()) does not trigger when user enters from outside document window
      var $this = $(this);
      if ($this.prop('hoverTimeout')) {
        $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
      }
      $this.prop('hoverIntent', setTimeout(function() {
        $this.addClass('hover');
      }, 200));
    })
    .on('mouseleave', function() {
      var $this = $(this);
      if ($this.prop('hoverIntent')) {
        $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
      }
      $this.prop('hoverTimeout', setTimeout(function() {
        $this.removeClass('hover');
      }, 400));
    }); 

  // Homepage Navigation On Hover
  function hoverEvents (){
    $('.top-nav li').on('mouseover', function() {
      $(this).addClass('hover');
    });
    $('.top-nav li').on('mouseout', function() {
      $(this).removeClass('hover');
    }); 
    $(".top-nav").on('mouseover', function () { 
      $(".header-container").addClass("hover"); 
    });
    $(".top-nav").on('mouseout', function () { 
      $(".header-container").removeClass("hover"); 
    });
  }

  // Searchbox
  var submitIcon = $('#btn-search');
  var inputBox = $('.search input[type="search"]');
  var searchBox = $('.search');
  var isOpen = false;

  submitIcon.on('click',function() {
    if (isOpen == false) {
      searchBox.addClass('searchbox-open');
      inputBox.trigger('focus');
      isOpen = true;
      // console.log('search open')
    } else {
      searchBox.removeClass('searchbox-open');
      inputBox.trigger('focusout');
      isOpen = false;
      // console.log('search close')
    }
  });

  submitIcon.on('mouseup',function() {
    return false;
  });

  searchBox.on('mouseup',function() {
    return false;
  });

  $(document).on('mouseup', function() {
    if (isOpen == true) {
      $('.icon-search').css('display', 'block');
      submitIcon.trigger('click');
    }
  });
});

// Outside Doc.ready

function buttonUp() {
  var inputVal = $('.search input[type="search"]').val();
  inputVal = inputVal.trim().length;
  if (inputVal !== 0) {
    $('#searchSubmit').addClass('show');
  } else {
    $('.search input[type="search"]').val('');
    $('#searchSubmit').removeClass('show');
  }
} 
/*End SH-scripts */
	